var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imageBanner",style:('padding: 0 ' + _vm.item.lrEdge.val + 'px;margin-top:' + _vm.item.mbConfig.val +'px;')},[_c('div',{staticClass:"banner",class:{'border-radius': _vm.item.bgStyle.type === 1}},_vm._l((_vm.item.menuConfig.list),function(items,indexs){return _c('img',{attrs:{"src":items.img}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }